










import { Component, Vue, Ref, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import MatchFieldsHeader from '@/features/matchFields/components/MatchFieldsHeader.vue'
import MatchFieldsList from '@/features/matchFields/components/MatchFieldsList.vue'
import MatchFieldsIssues from '@/features/matchFields/components/MatchFieldsIssues.vue'
import MatchFieldsNavigationBtn from '@/features/matchFields/components/MatchFieldsNavigationBtn.vue'
import ChooseTimeFormat from '@/features/matchFields/components/ChooseTimeformat.vue'
import ChooseTzDialog from '@/features/matchFields/components/ChooseTzDialog.vue'
import WatchOnJob from '@/shared/WatchOnJob.mixin.vue'
import MatchFieldsSelect from '@/features/matchFields/components/MatchFieldsSelect.vue'

import {
  GET_SELECTED_PROJECTS,
  GET_JOB_ID,
  GET_MATCHER,
  GET_MATCHER_FOR_DISPLAY,
  GET_DATE_TIME_FORMAT,
  GET_SELECTED_TZ,
  GET_ERRORS
} from '@/system/store/getter-types'
import { TRANSFORM_DATA_ACTION, CLEAR_MATCH_FIELDS_DATA } from '@/system/store/action-types'
import { IProjectStore, ISelectedProjects } from '@/features/projectList/store'
import { IActionType } from '@/system/store'
import WebSocketService from '@/system/socket/socket.service'

@Component({
  components: {
    MatchFieldsHeader,
    MatchFieldsList,
    MatchFieldsIssues,
    MatchFieldsNavigationBtn,
    ChooseTimeFormat,
    ChooseTzDialog,
    MatchFieldsSelect
  }
})

export default class MatchFieldsView extends Mixins(WatchOnJob) {
  private service = new WebSocketService()
  private unwatch: any
  @Ref()
  readonly modal!: ChooseTzDialog
  @Ref()
  readonly listModal!: MatchFieldsList

  @Getter(GET_SELECTED_PROJECTS)
  selectedProjects!: ISelectedProjects[]
  @Getter(GET_DATE_TIME_FORMAT)
  dateTimeFormat!: string
  @Getter(GET_JOB_ID)
  jobId!: string
  @Getter(GET_MATCHER)
  matcher!: string
  @Getter(GET_MATCHER_FOR_DISPLAY)
  matcherForDisplay!: any[]
  @Getter(GET_SELECTED_TZ)
  selectedTz!: string

  @Action(TRANSFORM_DATA_ACTION)
  transformData!: IActionType
  @Action(CLEAR_MATCH_FIELDS_DATA)
  clearMatchFieldsData!: IActionType

  private created (): void {
    this.clearMatchFieldsData()
    this.unwatch = this.watchOnValidationFailedStatus()
  }

  protected destroyed (): void {
    this.unwatch()
  }

  showDialog () {
    this.modal.openDialog()
  }

  runValidation () {
    const selectModal: MatchFieldsSelect = this.listModal.getSelectModal()
    selectModal.handleValidation()
  }

  private sendMatcher (nextPage: string): void {
    this.selectedProjects.forEach((project: ISelectedProjects) => {
      this.transformData({
        dateTimeFormat: this.dateTimeFormat,
        job: this.jobId,
        selectedTz: this.selectedTz,
        matcher: this.matcher,
        project
      })
    })

    this.$router.push({ name: nextPage })
  }
}
